import { NavPayloadAction } from '@carvana/merch-native';
import { useMemo } from 'react';
import { useSearchRequestId } from '~/context/srp/InventoryContext';

export default function useNativeVDPPayload(vehicleId?: number) {
  const searchRequestId = useSearchRequestId();

  return useMemo(
    () =>
      JSON.stringify({
        action: NavPayloadAction.ViewVdp,
        searchRequestId,
        vehicleId
      }),
    [searchRequestId, vehicleId]
  );
}
